import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import apiLink from "../../../api/apiLink";
import Loader from "../../../components/common/Loader";

import { useTranslation } from "react-i18next";
import useISPowner from "../../../hooks/useISPOwner";

function SalarySMSTemplate() {
  const { t } = useTranslation();

  //---> @Get user & current user data form useISPOwner hooks
  const { ispOwnerId, bpSettings, settings } = useISPowner();

  const [loading, setLoading] = useState(false);
  const [salarySMS, setSalarySMS] = useState(false);
  const [salarySendingType, setSalarySendingType] = useState("");

  const messageTypes = [
    {
      name: "nonMasking",
      label: t("nonMasking"),
      value: "nonMasking",
    },
    {
      name: "masking",
      label: t("masking"),
      value: "masking",
    },
    {
      name: "fixedNumber",
      label: t("fixedNumber"),
      value: "fixedNumber",
    },
    ...(bpSettings?.hasSmsGateway
      ? [
          {
            name: "personalGateway",
            label: t("personalGateway"),
            value: "personalGateway",
          },
        ]
      : []),
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    let data = {
      ...settings.sms,
      staffSalarySendBy: salarySendingType,
      staffSalary: salarySMS,
    };
    setLoading(true);
    try {
      await apiLink.patch(`/ispOwner/settings/sms/${ispOwnerId}`, data);
      setLoading(false);
      toast.success(t("SalarySMSToast"));
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    setSalarySMS(settings.sms.staffSalary);
    setSalarySendingType(settings?.sms?.staffSalarySendBy);
  }, [settings]);

  return (
    <div>
      <div className="writeMessageSection">
        <div className="messageStatus d-flex justify-content-between">
          <div className="sending-status">
            <h4> {t("SalarySMSTemplate")} </h4>
            <div className="displayGrid1">
              <div className="message_radio">
                <input
                  type="radio"
                  name="salarySMS"
                  id="onTemplate_salary"
                  checked={salarySMS}
                  onChange={() => setSalarySMS(true)}
                />
                <label htmlFor="onTemplate_salary">{t("ON")}</label>
              </div>

              <div className="message_radio">
                <input
                  type="radio"
                  name="salarySMS"
                  id="offTemplate_salary"
                  checked={!salarySMS}
                  onChange={() => setSalarySMS(false)}
                />
                <label htmlFor="offTemplate_salary">{t("OFF")}</label>
              </div>
            </div>
          </div>
          <div className="message-sending-type">
            <h4>{t("sendingMessageType")}</h4>
            <div className="smsType">
              {messageTypes.map((type) => (
                <div className="message_radio" key={type.value}>
                  <input
                    type="radio"
                    id={type.value + "salary"}
                    value={type.value}
                    onChange={(event) =>
                      setSalarySendingType(event.target.value)
                    }
                    checked={salarySendingType === type.value}
                  />
                  <label htmlFor={type.value + "salary"}>{type.label}</label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <hr />
      <button type="submit" onClick={handleSubmit} className="btn btn-success">
        {loading ? <Loader /> : t("save")}
      </button>
    </div>
  );
}

export default SalarySMSTemplate;
